import React from 'react';
import { heroContent } from '../mock';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const handleJoinNow = () => {
    const contactSection = document.querySelector('#contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleFreeTrial = () => {
    const contactSection = document.querySelector('#contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroContent.backgroundImage}
          alt="Gym Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 relative z-10 py-32">
        <div className="max-w-3xl">
          <h1 className="hero-title text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6 animate-fade-in-up">
            {heroContent.title}
          </h1>
          <p className="hero-subtitle text-2xl md:text-3xl text-brand-primary font-bold mb-12 tracking-wide animate-fade-in-up-delay">
            {heroContent.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up-delay-2">
            <button
  onClick={handleJoinNow}
  className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg 
             hover:bg-white hover:text-black 
             transition-all duration-300 flex items-center justify-center gap-2"
>
  Join Now
</button>

            <button
              onClick={handleFreeTrial}
              className="btn-secondary border-2 border-brand-primary text-brand-primary px-8 py-4 rounded-full font-bold text-lg hover:bg-brand-primary hover:text-black transform hover:scale-105 transition-all duration-300 shadow-lg"
            >
              Book Free Trial
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-brand-primary rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-brand-primary rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;


